import {inject, injectable} from "tsyringe";
import {IHttpService} from "frontend-core";
import {AgentTree, IAgentTreeDTO} from "@/modules/Segmentation/models/AgentTree";
import {IAgentTreeService} from "@/modules/Segmentation/services/IAgentTreeService";

@injectable()
export class AgentTreeService implements IAgentTreeService {
    constructor(
        @inject("IHttpService")
        private readonly http: IHttpService,
    ) {
    }

    async getChildren(id: string, recursive?: boolean): Promise<AgentTree[]> {
        let array: AgentTree[] = [];

        await this.http.api.get<IAgentTreeDTO[]>(`/agents/${id}/children`)
            .then(async (data) => {
                array.push(
                    ...data.data.map((item) => new AgentTree(item)),
                );

                if (recursive) {
                    for (const item of array) {
                        if (item.children) {
                            item.children = await this.getChildren(item.id, true);
                        }
                    }
                }
            });

        return array;
    }
}
